<template>
  <div class="abnormal-driver-page">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>异常司机</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">创建日期</span>
        <el-date-picker
          v-model="filter.startTime"
          type="date"
          style="width: 140px"
          disabled
          value-format="timestamp"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker v-model="filter.endTime" type="date" style="width: 140px" value-format="timestamp" disabled>
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">异常类型</span>
        <el-select v-model="abnormalTypeArr" multiple collapse-tags placeholder="请选择" class="multiple-select-ie">
          <el-option v-for="item in abnormalTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="demonstration">筛选条件</span>
        <el-input
          v-model.trim="filter.qryString"
          style="width: 200px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="输入司机、手机号搜索"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-3">
        <el-button type="primary" size="small" @click="search">筛选</el-button>
      </div>
    </div>
    <div class="table-custom-box mt-10" id="auto-4">
      <el-table :data="tableData.data" border>
        <el-table-column label="司机" width="160">
          <template v-slot="scope">
            {{ scope.row.driverName }}
            <span
              v-if="scope.row.driverNameListType"
              :class="[scope.row.driverNameListType == 1 ? 'yellow-tag' : 'white-tag']"
              >{{ scope.row.driverNameListType == 1 ? '黄名单' : '白名单' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="driverPhone" label="手机号" width="160"> </el-table-column>
        <el-table-column prop="abnormalOrderCount" label="异常运单数" width="160"> </el-table-column>
        <el-table-column prop="abnormalTypeDesc" label="异常类型"> </el-table-column>
        <el-table-column label="操作" width="140">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)">查看运单明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import { WUYI, vali } from '@/api/common';
export default {
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      companyCode: WUYI.currentData.company.companycode,
      abnormalTypeArr: [],
      filter: {
        startTime: '',
        endTime: '',
        multiAbnormalType: '',
        qryString: ''
      },
      cache: {},
      tableData: {
        total: 0,
        data: []
      },
      abnormalTypeList: [
        { label: '无定位', value: 1, name: 'location' },
        { label: '中途停车', value: 2, name: 'park' },
        { label: '运输超时', value: 4, name: 'timeout' },
        { label: 'APP离线', value: 8, name: 'offLine' },
        { label: '黑名单地点停车', value: 32, name: 'blacklistStop' },
        { label: '夜间停车', value: 512, name: 'nightStop' },
        { label: '中交全程无定位', value: 128, name: 'noLocationWhole' },
        { label: '超速', value: 1024, name: 'overspeed' },
        { label: '超载', value: 2048, name: 'overload' },
        { label: '疲劳驾驶', value: 4096, name: 'drowsy' },
        { label: '风险车辆', value: 8192, name: 'riskcar' },
        { label: '风险司机', value: 16384, name: 'riskdriver' }
      ]
    };
  },
  watch: {
    abnormalTypeArr(arr) {
      this.filter.multiAbnormalType = arr.join(',');
    }
  },
  created() {
    const type = this.$route.query.type;
    const sDate = this.$route.query.sDate;
    const eDate = this.$route.query.eDate;
    if (!sDate || !eDate) {
      this.$router.push({ name: 'DrivingControl' });
      return;
    }
    if (type) {
      // 多个异常类型以&隔开
      let abnormalTypeName = type.split('&');
      this.abnormalTypeArr = abnormalTypeName.map(el => this.getAbnormalType(el));
      this.filter.multiAbnormalType = this.abnormalTypeArr.join(',');
    }
    this.filter.startTime = +sDate;
    this.filter.endTime = +eDate;
    this.search();
  },
  methods: {
    getAbnormalType(type) {
      return this.abnormalTypeList.filter(item => item.name == type)[0].value;
    },
    search() {
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.featchData();
    },
    featchData() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        companyCode: this.companyCode,
        ...this.cache
      };
      axiosNew.post(api.listAbnormalDriver, options).then(res => {
        this.tableData = res.data;
      });
    },
    //分页点击
    handleCurrentChange(val) {
      this.currentPage = val;
      this.featchData();
    },
    getAbnormalName(value) {
      return this.abnormalTypeList.filter(item => item.value == value)[0].name;
    },
    handleClick(item) {
      let abnormalTypeList = this.cache.multiAbnormalType ? this.cache.multiAbnormalType.split(',') : [];
      let abnormalTypeArr = [];
      let abnormalType = '';
      if (abnormalTypeList.length > 0) {
        abnormalTypeArr = abnormalTypeList.map(el => this.getAbnormalName(el));
        abnormalType = abnormalTypeArr.join('&');
      }
      if (abnormalType) {
        this.$router.push({
          path: '/abnormalDriverDetail',
          query: {
            type: 'driver',
            abnormalType,
            driverCode: item.driverCode,
            sDate: this.cache.startTime,
            eDate: this.cache.endTime
          }
        });
      } else {
        this.$router.push({
          path: '/abnormalDriverDetail',
          query: {
            type: 'driver',
            driverCode: item.driverCode,
            sDate: this.cache.startTime,
            eDate: this.cache.endTime
          }
        });
      }
    }
  }
};
</script>
